import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withIntl from '../../../../components/Intl/WithIntl';
import { Row, Col, Collapse, ButtonGroup, Button, Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { dateFromNow, dateFormat } from '../../../../util/date';

import { getMessageAuthorId } from '../../ConversationActions';

import FileLoader from '../../../../components/Content/FileLoader';
import UserProfileImage from '../../../User/components/profile/UserProfileImage';
import { Link } from 'react-router-dom';

class MessageView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            collapse: false,
            isFileLoading: false,
            fileUrl: '',
            displayRelativeDate: true,
        };
    }

    getWriterName = () => {
        if(this.isWriter()) {
            return this.props.intl.messages.you;
        }
        return this.props.message.author.firstName;
    };

    getFormattedDate = () => {
        return this.props.isReport || this.state.displayRelativeDate ? `${dateFormat(this.props.message.date)} GMT` : dateFromNow(this.props.message.date);
    };

    getMessageWrapperClassName = () => {
        let classes = 'mt-0 conversation-message ';
        if(this.props.message.type === 'system') {
            classes += 'conversation-message-fromsystem ';
        } else if(this.isWriter()) {
            classes += 'conversation-message-fromme ';
        } else if(this.props.message.author) {
            classes += 'conversation-message-fromother ';
        }
        return classes;
    };

    isWriter = () => {
        return this.props.message.author && this.props.message.author._id === this.props.user._id;
    }

    toggle = () => {
        this.setState({ collapse: !this.state.collapse });
    };

    renderMessageFile() {
        return <FileLoader filename={this.props.message.file} owner={getMessageAuthorId(this.props.message)} app-filename={this.props.message.file} className="conversation-attached-file" onClick={() => this.props.openLightbox(this.props.message.file)} alt={this.props.message.text} />;
    }

    renderMessageContent() {
        const { message } = this.props;
        return (
            <div className={`conversation-message-content ${message.type === 'system' ? 'text-center' : (this.isWriter() ? 'text-end' : 'text-start')}`} onClick={this.toggle}>
                {message && message.file && this.renderMessageFile()}
                {
                    message.type === 'system'
                    ? <FormattedMessage id={message.text} values={message.data} />
                    : message.text
                } {' '}

                <Collapse isOpen={this.state.collapse}>
                    <em><small onClick={event => { event.stopPropagation(); this.setState({ displayRelativeDate: !this.state.displayRelativeDate }); }}>{this.getFormattedDate()}</small></em>
                    {' '}{this.props.addMessageDateLink && <Link to={`?time=${message.date}`}><FontAwesomeIcon icon="clock" /></Link>}
                </Collapse>
            </div>
        );
    }

    renderMessageAuthor() {
        return (
            <div className="mx-1">
                {this.props.displayAuthor ? <UserProfileImage user={this.props.message.author} /> : <div className="mx-1" style={{ width: '30px' }}>{' '}</div>}
            </div>
        );
    }

    render() {
        const { user, message } = this.props;

        if(message.type === 'system') {
            return (
                <div className={this.getMessageWrapperClassName()}>
                    <div className="text-center">
                        {this.renderMessageContent()}
                    </div>
                </div>
            );
        }
        if(this.isWriter()) {
            return (
                <div className="d-flex justify-content-end">
                    {this.renderMessageContent()}
                    {this.renderMessageAuthor()}
                </div>
            );
        }
        return (
           <div className="d-flex justify-content-start">
                {this.renderMessageAuthor()}
                {this.renderMessageContent()}
           </div>
        );
    }
}

// <ButtonGroup>
//     {this.props.message.hideToCustomer ? <Button color="info" outline size="sm"><FontAwesomeIcon icon="eye-slash" /></Button> : null}
//     {this.props.message.file ? <Button outline color="warning" size="sm" disabled={this.state.isFileLoading} onClick={() => this.loadFile()}><FontAwesomeIcon icon="refresh" spin={this.state.isFileLoading} /></Button> : null }
//     <Button  outline size="sm" color="dark"><FontAwesomeIcon icon={this.state.collapse ? 'caret-up' : 'caret-down'} /></Button>
// </ButtonGroup>

function mapStateToProps(store, props) {
    return {
        user: store.users.user,
    };
}

MessageView.propTypes = {
    intl: PropTypes.object.isRequired,
    user: PropTypes.object,
    isReport: PropTypes.bool,
    message: PropTypes.object.isRequired,
    displayAuthor: PropTypes.bool,
    openLightbox: PropTypes.func,
    addMessageDateLink: PropTypes.bool,
};

export default connect(mapStateToProps)(withIntl(MessageView));
